import * as t from 'io-ts';
import { unwrapResult } from '@reduxjs/toolkit';
import { store } from '../store';
import * as IMThunk from '../store/sessions/tim.thunk';
import { Message } from '../tccc';
import { SessionAdapter } from './SessionAdapter';

type OmitEndChatParams = 'closeBy' | 'emitter';
export class Chat extends SessionAdapter {
  seatInChat = (args: Omit<Parameters<typeof IMThunk.accessIMSession>[0], 'emitter'>) =>
    store.dispatch(IMThunk.accessIMSession({ ...args, emitter: this.sdk })).unwrap();

  endChat = (args: Omit<Parameters<typeof IMThunk.endIMSession>[0], OmitEndChatParams>) =>
    store.dispatch(IMThunk.endIMSession({ ...args, emitter: this.sdk, closeBy: 'seat' })).unwrap();
  sendSessionRating = (args: Omit<Parameters<typeof IMThunk.sendIMSessionRating>[0], 'sdk'>) =>
    store.dispatch(IMThunk.sendIMSessionRating({ ...args, sdk: this.sdk })).unwrap();
  getMessageList = (args: Omit<Parameters<typeof IMThunk.getMessageList>[0], 'tccc'>) =>
    store.dispatch(IMThunk.getMessageList({ tccc: this.sdk, ...args })).unwrap();
  revokeMessage = (message: Message) => store.dispatch(IMThunk.revokeMessage({ tccc: this.sdk, message })).unwrap();
  resendMessage = (message: Message) => store.dispatch(IMThunk.resendMessage({ tccc: this.sdk, message })).unwrap();
  getInnerConversationList = () => store.dispatch(IMThunk.getInnerConversations({ tccc: this.sdk })).unwrap();
  setMessageRead = (args: Omit<Parameters<typeof IMThunk.setMessageRead>[0], 'tccc'>) =>
    store.dispatch(IMThunk.setMessageRead({ tccc: this.sdk, ...args })).unwrap();
  markUnread = (args: Omit<Parameters<typeof IMThunk.markUnread>[0], 'tccc'>) =>
    store.dispatch(IMThunk.markUnread({ tccc: this.sdk, ...args })).unwrap();
  transfer = (args: t.TypeOf<typeof IMThunk.TransferParams>) =>
    store.dispatch(IMThunk.transferIM({ ...args, sdk: this.sdk })).unwrap();
  createTextMessage = (args: Omit<Parameters<typeof IMThunk.createTextMessage>[0], 'tccc'>) =>
    store.dispatch(IMThunk.createTextMessage({ tccc: this.sdk, ...args })).unwrap();
  createImageMessage = (args: Omit<Parameters<typeof IMThunk.createImageMessage>[0], 'tccc'>) =>
    store.dispatch(IMThunk.createImageMessage({ tccc: this.sdk, ...args })).unwrap();
  createCustomMessage = (args: Omit<Parameters<typeof IMThunk.createCustomMessage>[0], 'tccc'>) =>
    store.dispatch(IMThunk.createCustomMessage({ tccc: this.sdk, ...args })).unwrap();
  createFileMessage = (args: Omit<Parameters<typeof IMThunk.createFileMessage>[0], 'tccc'>) =>
    store.dispatch(IMThunk.createFileMessage({ tccc: this.sdk, ...args })).unwrap();
  createVideoMessage = (args: Omit<Parameters<typeof IMThunk.createVideoMessage>[0], 'tccc'>) =>
    store.dispatch(IMThunk.createVideoMessage({ tccc: this.sdk, ...args })).unwrap();
  sendMessage = (message: Message, options?: { onlineUserOnly: boolean }) =>
    store.dispatch(IMThunk.sendMessage({ tccc: this.sdk, message, options })).unwrap();
  sendMessageReadReceipt = (args: Omit<Parameters<typeof IMThunk.sendMessageReadReceipt>[0], 'tccc'>) =>
    store.dispatch(IMThunk.sendMessageReadReceipt({ tccc: this.sdk, ...args })).unwrap();
  inviteAudio = (args: Omit<Parameters<typeof IMThunk.inviteMedia>[0], 'tccc' | 'type'>) =>
    store.dispatch(IMThunk.inviteMedia({ tccc: this.sdk, type: 'audio', ...args })).unwrap();
  inviteVideo = (args: Omit<Parameters<typeof IMThunk.inviteMedia>[0], 'tccc' | 'type'>) =>
    store.dispatch(IMThunk.inviteMedia({ tccc: this.sdk, type: 'video', ...args })).unwrap();
  endAudio = (args: Omit<Parameters<typeof IMThunk.endInviteMedia>[0], 'emitter'>) =>
    store.dispatch(IMThunk.endInviteMedia({ emitter: this.sdk, ...args })).then(unwrapResult);
  endVideo = (args: Omit<Parameters<typeof IMThunk.endInviteMedia>[0], 'emitter'>) =>
    store.dispatch(IMThunk.endInviteMedia({ emitter: this.sdk, ...args })).then(unwrapResult);
}
